import { canAssignRole } from "../../../utils/roleHelpers";

/**
 * Updates a user in the users array
 * @param {Array} users - Array of user objects
 * @param {string} userEmail - Email of user to update
 * @param {Object} updates - Object containing fields to update
 * @returns {Array} Updated users array
 */
export const updateUserInList = (users, userEmail, updates) => {
  return users.map((user) =>
    user.email === userEmail ? { ...user, ...updates } : user
  );
};

/**
 * Filters roles based on current user's permissions
 * Only Super Admin can see/assign Super Admin role
 * @param {Array} roles - Array of role objects with id property
 * @param {Object} currentUser - Current logged-in user object with role_id property
 * @returns {Array} Filtered roles array
 */
export const getAssignableRoles = (roles = [], currentUser = null) => {
  if (!roles || roles.length === 0) {
    return [];
  }

  return roles.filter((role) => {
    const roleId = Number(role.id || role.value);
    return canAssignRole(currentUser, roleId, roles);
  });
};
